document.addEventListener("DOMContentLoaded", () => {
    const viewBtn = document.querySelector(".color-swatcher .color-swatch__view-btn");
    const swatches = Array.from(document.querySelectorAll(".color-swatcher .color-swatch"));
    const hiddenSwatches = swatches.filter(el => el.classList.contains("hidden"));
    const swatchLabel = document.querySelector(".color-swatch__label");
    const currentSwatchLabel = swatchLabel.textContent;
    
    swatches.forEach(swatch => {
        ["mouseenter", "click"].forEach(evt => {
            swatch.addEventListener(evt, () => {
                let label = swatch.dataset.colorLabel;
                swatchLabel.textContent = label;
            })
        })

        swatch.addEventListener("mouseleave", () => {
            swatchLabel.textContent = currentSwatchLabel;
        })        
    })

    if (viewBtn) {
        viewBtn.addEventListener("click", () => {
            hiddenSwatches.forEach(el => el.classList.remove("hidden"));
            viewBtn.remove();
        })
    }
})